/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class OwnershipBasisGrid extends SiteEntityGrid<OwnershipBasisRow, any> {
        protected getColumnsKey() { return 'Data.OwnershipBasis'; }
        protected getDialogType() { return OwnershipBasisDialog; }
        protected getIdProperty() { return OwnershipBasisRow.idProperty; }
        protected getLocalTextPrefix() { return OwnershipBasisRow.localTextPrefix; }
        protected getService() { return OwnershipBasisService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}